'use client'

import dynamic from 'next/dynamic'

import { SearchSkeleton } from './search-skeleton'

export const SearchPageContentClient = dynamic(
  () => import('./search-page-content').then(mod => mod.SearchPageContent),
  {
    ssr: false,
    loading: () => <SearchSkeleton />,
  },
)

export const SearchPageContentClassesClient = dynamic(
  () => import('./search-page-content').then(mod => mod.SearchPageContent),
  {
    ssr: false,
    loading: () => <SearchSkeleton isClasses />,
  },
)
